// import { Form } from 'antd';
// import styles from './searchGroup.less?modules';
import React, { useState, useEffect } from 'react';
// import Autocomplete from '@mui/material/Autocomplete';
// import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@material-ui/core/TextField';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  // Autocomplete,
  // CircularProgress,
} from '@material-ui/core';
// import { channelMapList } from '@/constants.js';
// import { useDispatch, useSelector } from 'dva';
import Button from '@material-ui/core/Button';
import { useIntl } from 'umi';
import DateRangePickerML from '@/components/DateRangePickerML';
// import AutoComplateML from '@/components/AutoComplateML';
import SearchGroupStyled from './SearchGroupStyled';
import { createOid } from '@/utils/eventtracing';
// function sleep(delay = 0) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, delay);
//   });
// }
// function debounce(fn, ms = 2000) {
//   let timer;
//   return function (...args) {
//     if (timer) {
//       clearTimeout(timer);
//     }
//     timer = setTimeout(() => {
//       fn(...args);
//       timer = null;
//     }, ms);
//   };
// }

const SearchGroup = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { levels = [], query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const {
    channel,
    gender,
    memberCode,
    mobile,
    name,
    level,
    // manageStore: ManageStore,
    // registerStore: RegisterStore,
    signUpDateEnd,
    signUpDateStart,
  } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      channel,
      gender,
      memberCode,
      mobile,
      name,
      level,
      date: { startDate: signUpDateStart, endDate: signUpDateEnd },
    },
  });
  // 每个输入框清除数据
  //置空输入框
  const handleClearLevel = () => {
    setValue('level', '');
    // reset('level', '');
  };
  // const handleClearChannel = () => {
  //   setValue('channel', '');
  //   // reset('channel', '');
  // };
  // const watchChannel = watch('channel');
  const watchLevel = watch('level');
  const [memberCodeValue, setMemberCodeValue] = useState();
  const [nameValue, setNameValue] = useState();
  const [mobileValue, setMobileValue] = useState();
  //初始状态保持的时候
  useEffect(() => {
    if (memberCode) {
      setMemberCodeValue(memberCode);
    }
    if (name) {
      setNameValue(name);
    }
    if (mobile) {
      setMobileValue(mobile);
    }
  }, [memberCode, mobile, name]);
  //控制日期控件的重置
  const [isReset, setIsReset] = useState(false);
  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const manageStore = msValue?.join('/');
    const registerStore = rsValue?.join('/');
    const propsSubmitData = {
      ...submitData,
      manageStore,
      registerStore,
      signUpDateEnd: submitData.date?.endDate,
      signUpDateStart: submitData.date?.startDate,
    };
    delete propsSubmitData.date;
    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      channel: '',
      gender: '',
      level: '',
      memberCode: '',
      mobile: '',
      name: '',
      date: null,
    };
    setMobileValue('');
    setMemberCodeValue('');
    setNameValue('');
    reset(resetSearch);
    setIsReset(true);
    setMsValue([]);
    setRsValue([]);
    const propsResetSearch = {
      channel: '',
      gender: '',
      level: '',
      memberCode: '',
      mobile: '',
      name: '',
      registerStore: '',
      manageStore: '',
      registerStoreName: '',
      manageStoreName: '',
      signUpDateEnd: null,
      signUpDateStart: null,
    };
    restClick && restClick(propsResetSearch);
  };
  // 状态保持时注册门店和服务门店
  // const defaultRegisterStore = useMemo(() => {
  //   let RegisterStoreArray = [];
  //   if (RegisterStore) {
  //     RegisterStoreArray = RegisterStore.split('/');
  //   }
  //   return RegisterStoreArray;
  // }, [RegisterStore]);

  // const defaultManageStore = useMemo(() => {
  //   let ManageStoreArray = [];
  //   if (ManageStore) {
  //     ManageStoreArray = ManageStore.split('/');
  //   }
  //   return ManageStoreArray;
  // }, [ManageStore]);

  // useEffect(() => {

  //   if (ManageStore) {
  //     const ManageStoreArray = ManageStore.split('-');
  //     setMsValue(ManageStoreArray);
  //   }
  // }, [ManageStore, RegisterStore]);
  //异步输入下拉框
  //注册门店输入框
  const [rsValue, setRsValue] = useState([]);
  const [msValue, setMsValue] = useState([]);

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line" mb={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="memberCode"
                    variant="standard"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl01',
                    })}
                    value={rp.value ?? memberCodeValue}
                    onChange={(e) => {
                      setValue('memberCode', e.target.value);
                      setMemberCodeValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setMemberCodeValue('');
                              setValue('memberCode', '');
                            }}
                            edge="end"
                          >
                            {memberCodeValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="memberCode"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />

              <Controller
                render={(rp) => (
                  <TextField
                    name="name"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl02',
                    })}
                    defaultValue=""
                    value={rp.value ?? nameValue}
                    onChange={(e) => {
                      setValue('name', e.target.value);
                      setNameValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('name', '');
                              setNameValue('');
                            }}
                            edge="end"
                          >
                            {nameValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="name"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'adjustment.members.n01.lbl02' })}
                defaultValue=""
              />
              <Controller
                // as={TextField}
                render={(rp) => (
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    value={rp.value ?? mobileValue}
                    className="input"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl03',
                    })}
                    defaultValue=""
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      setMobileValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                              setMobileValue('');
                            }}
                            edge="end"
                          >
                            {mobileValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                control={control}
                // helperText={Boolean(errors.mobile) && '请输入会员手机号'}
                // rules={{ required: true }}
                // error={Boolean(errors.mobile)}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'adjustment.members.n01.lbl03' })}
                defaultValue=""
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>
                  {formatMessage({ id: 'adjustment.members.n01.rdo04' })}
                </InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('mobile', '')}
                              edge="end"
                            >
                              {/* {getValues().memberCode ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )} */}
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {levels &&
                        levels.map((item) => (
                          <MenuItem
                            key={item.code}
                            value={item.code}
                            name={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'adjustment.members.n01.rdo04' })}
                  name="level"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                {watchLevel ? (
                  <ClearIconML
                    handleClick={handleClearLevel}
                    clearValue={watchLevel}
                  ></ClearIconML>
                ) : (
                  ''
                )}
              </FormControl>
            </Box>
            <Box className="line">
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      // label="注册日期"
                      startText={formatMessage({
                        id: 'adjustment.members.n01.rdo06',
                      })}
                      endText={formatMessage({
                        id: 'adjustment.members.n01.rdo07',
                      })}
                      defaultStartDate={
                        signUpDateStart ? signUpDateStart : null
                      }
                      defaultEndDate={signUpDateEnd ? signUpDateEnd : null}
                      rp={rp}
                      onChange={() => {
                        setIsReset(false);
                      }}
                      name="custom-form-submit-name"
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
              <div></div>
              <div></div>
              <div></div>
              {/* <Autocomplete
                  id="asynchronous-demo"
                  value={rsValue}
                  inputValue={rsInputValue}
                  open={openRegisterStore}
                  onOpen={() => {
                    setOpenRegisterStore(true);
                  }}
                  onChange={(event, newValue) => {
                    console.log('newValue', newValue);
                    setRsValue(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    setRsInputValue(newInputValue);
                  }}
                  onClose={() => {
                    setOpenRegisterStore(false);
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  options={rsOptions}
                  loading={RegisterStoreLoading}
                  renderInput={(params) => {
                    return (
                      <TextField
                        {...params}
                        label="注册门店"
                        variant="standard"
                        name="registerStore"
                        placeholder="请输入门店名称"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                        onChange={debounce((e) => {
                          setRegisterStoreName(e.target.value);
                        })}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {RegisterStoreLoading ? (
                                <CircularProgress color="inherit" size={16} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    );
                  }}
                /> */}
              {/* <Autocomplete
                  id="asynchronous-demo"
                  // sx={{ width: 300 }}
                  value={msValue}
                  inputValue={msInputValue}
                  onChange={(event, newValue) => {
                    setMsValue(newValue);
                  }}
                  onInputChange={(event, newValue) => {
                    setMsInputValue(newValue);
                  }}
                  open={openManageStore}
                  onOpen={() => {
                    setOpenManageStore(true);
                  }}
                  onClose={() => {
                    setOpenManageStore(false);
                  }}
                  isOptionEqualToValue={(option, value) => {
                    console.log('option, value', option, value);
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  options={msOptions}
                  loading={ManageStoreLoading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="服务门店"
                      placeholder="请输入门店名称"
                      variant="standard"
                      name="manageStore"
                      onChange={debounce((e) => {
                        setManagerStoreName(e.target.value);
                      })}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {ManageStoreLoading ? (
                              <CircularProgress color="inherit" size={16} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                ></Autocomplete> */}
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: createOid('ev'),
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};

export default SearchGroup;
